import 'array.of';
require('array.from').shim();
require('array-includes').shim();
import 'string.prototype.repeat';
import 'string.prototype.startswith';
import 'ts-helpers';



/** WEBPACK FOOTER **
 ** ./~/source-map-loader!./src/polyfills.ts
 **/